<template>
  <v-card class="filter-panel" elevation="0">
    <h1 class="filter-title">{{ formTitle }}</h1>
    <v-form ref="form" v-model="valid" validate-on="lazy">
      <v-row dense>
        <v-col cols="12" md="4">
          <v-autocomplete
            label="Finca"
            v-model="landBatch.parentId"
            no-data-text="No se encontraron lugares."
            item-value="id"
            item-title="name"
            :items="farmLocations"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"
            density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Nombre de lote"
            v-model="landBatch.name"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"
            density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Cantidad de hectareas"
            v-model="landBatch.haAmount"
            type="number"
            min="0"
            :rules="[rules.requiredFieldRule, rules.min0]"
            variant="outlined"
            density="comfortable"
          />
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Observaciones"
            v-model="landBatch.note"
            auto-grow
            rows="3"
            variant="outlined"
            density="comfortable"
          />
        </v-col>
      </v-row>
      <div class="filter-actions">
        <v-btn color="primary" @click="save">Guardar lote</v-btn>
        <v-btn color="secondary" variant="tonal" @click="clearForm">
          {{ landBatch.id > 0 ? 'Cancelar edicion' : 'Limpiar formulario' }}
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { LOCATION_TYPES, locationsForType } from '@/services/location/LocationTypeUtils'

export default {
  name: 'AddEditLandBatchForm',
  emits: ['saved', 'cleared'],
  data: () => ({
    valid: true,
    rules: {
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0',
      requiredFieldRule: v => !!v || 'Campo requerido'
    },
    landBatch: {}
  }),

  computed: {
    ...mapGetters('locationModule', ['getLocations']),
    currentItem: function () {
      return this.$store.getters['landBatchModule/getSelectedItem']
    },
    farmLocations () {
      return locationsForType(this.getLocations, LOCATION_TYPES.FARM, this.landBatch.parentId)
    },
    formTitle () {
      return this.landBatch && this.landBatch.id > 0 ? `Editando lote: ${this.landBatch.name}` : 'Agregar lote'
    }
  },

  created () {
    this.clearForm()
  },

  watch: {
    currentItem: function (item) {
      this.landBatch = Object.assign({}, item || this.$store.getters['landBatchModule/getDefaultLandBatch'])
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  },

  methods: {
    async clearForm () {
      this.landBatch = Object.assign({}, this.$store.getters['landBatchModule/getDefaultLandBatch'])
      await this.$store.dispatch('landBatchModule/setSelectedItem', Object.assign({}, this.landBatch))
      this.valid = true
      await this.$nextTick()
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.$emit('cleared')
    },

    async save () {
      const validation = await this.$refs.form.validate()
      if (validation.valid) {
        try {
          await this.$store.dispatch('landBatchModule/saveLandBatch', this.landBatch)
          await this.clearForm()
          this.$emit('saved')
        } catch (e) {
          console.log('Error saving landBatch.', e)
        }
      }
    }
  }

}
</script>
